import * as stylex from "@stylexjs/stylex";
import { motion } from "framer-motion";
import { useRTL } from "hooks";
import Link from "next/link";
import { FormattedMessage, useIntl } from "react-intl";
import { findArticleAlias, findArticleThemeAlias, getArticleName, subthemesIndex, useAlias } from "routes";
import { breakpoints } from "../../materials/consts.stylex";
import { themeVars } from "../../materials/theme.stylex";
import { typography } from "../../materials/typography.stylex";
import { O, pipe } from "../../prelude";
const styles = {
    subtitleWeight: {
        k63SB2: "xo1l8bm xj8h6mu",
        $$css: true
    }
};
export default function SubThemesNavigation() {
    const alias = useAlias();
    const isRTL = useRTL();
    const intl = useIntl();
    const aliasArticle = findArticleAlias(alias);
    const subthemes = pipe(aliasArticle, O.fold(()=>[], (a)=>subthemesIndex[findArticleThemeAlias(a)]));
    return <motion.ul id="subnav" className="xwvj9da x78zum5 x1q0g3np xl56j7k">
      {subthemes.map((subtheme, index)=>{
        return <motion.li key={subtheme} className="x1b5akj9 xkddfq5 x1ypdohk x1l0rlnr xzs41jn xc342km xj6ak53 x1rbwscb xdpxx8g x2sfjvx x1yeuszv" style={{
            opacity: subtheme === alias ? 1 : 0.5,
            borderTopLeftRadius: index === 0 ? "4px" : 0,
            borderTopRightRadius: index === subthemes.length - 1 ? "4px" : 0
        }}>
            <Link href={`/articles/${subtheme}#subnav`} {...{
            0: {
                className: "x78zum5 x1q0g3np x6s0dn4 x1heor9g x167g77z x16if0ql xzt5al7"
            },
            1: {
                className: "x78zum5 x1q0g3np x6s0dn4 x1heor9g x167g77z x16if0ql xzyj77d"
            }
        }[!!isRTL << 0]}>
              <div {...{
            0: {
                className: "xdpxx8g"
            },
            1: {
                className: "x1hr2gdg"
            }
        }[!!isRTL << 0]}>
                <p {...stylex.props(typography.meta)}>
                  <FormattedMessage id="Sub-theme" defaultMessage="Sub-theme"/>
                </p>
                <h3 {...stylex.props(typography.heading4, styles.subtitleWeight)}>{getArticleName(intl, subtheme)}</h3>
              </div>
            </Link>
          </motion.li>;
    })}
    </motion.ul>;
}
